import InfoBar from "../infoBar.component";
import CountInfoTag from "../infoTags/count.infoTag.infoBar.component";
import { useContext, useEffect } from "react";
import { OrderedPartsContext } from "../../../contexts/parts/orderedParts.context";
import SelectedInfoTag from "../infoTags/selected/seletcted.infoTag.compnent";
// CONTEXTS
import { VendorsContext } from "../../../contexts/vendors.context";
import { SelectedOrderedPartsContext } from "../../../contexts/parts/selectedOrderedParts.part.context";
import { SelectedOpenPartOrdersContext } from "../../../contexts/parts/selectedOpenPartOrders.part.context";
// CONSTANTS
import DEFAULT_ORDERED_PARTS_COLUMNS from "../../../constants/parts/defaultOrderedPartsColumns";
import DEFAULT_OPEN_ORDERS_COLUMNS from "../../../constants/parts/defaultOpenOrdersColumns";

const OrderedPartsInfoBar = () => {
  const { vendors } = useContext(VendorsContext);
  const {
    selectedOrderedParts,
    removeSelectedOrderedPart,
    resetSelectedOrderedParts,
  } = useContext(SelectedOrderedPartsContext);
  const {
    selectedOpenPartOrders,
    removeSelectedOpenPart,
    resetSelectedOpenPartOrders,
  } = useContext(SelectedOpenPartOrdersContext);
  const { metaData } = useContext(OrderedPartsContext);
  const openPartsCount = selectedOpenPartOrders?.length || 0;
  const orderedPartsCount = selectedOrderedParts?.length || 0;

  return (
    <InfoBar>
      <CountInfoTag>Count: {metaData?.totalCount || 0}</CountInfoTag>
      <SelectedInfoTag
        handleClear={resetSelectedOpenPartOrders}
        handleSelect={removeSelectedOpenPart}
        handleSelectAll={resetSelectedOpenPartOrders}
        defaultColumns={DEFAULT_OPEN_ORDERS_COLUMNS}
        selectedData={selectedOpenPartOrders.map((openPart) => ({
          ...openPart,
          customer: openPart?.customer?.business_name,
          requested_date: openPart?.requested_date?.split("T")[0],
          received_date: openPart?.received_date?.split("T")[0],
          ordered_date: openPart?.ordered_date?.split("T")[0],
        }))}
        label={`Open Parts: ${openPartsCount}`}
      />
      <SelectedInfoTag
        handleClear={resetSelectedOrderedParts}
        handleSelect={removeSelectedOrderedPart}
        handleSelectAll={resetSelectedOrderedParts}
        defaultColumns={DEFAULT_ORDERED_PARTS_COLUMNS}
        label={`Ordered Parts: ${orderedPartsCount}`}
        selectedData={selectedOrderedParts.map((orderedPart) => ({
          ...orderedPart,
          tickets: orderedPart?.tickets
            ?.map((ticket) => ticket?.ticket)
            .join(", "),
          vendor: vendors.find((v) => v._id === orderedPart?.vendor)?.name,
          ordered_date: orderedPart?.ordered_date?.split("T")[0],
          received_date: orderedPart?.received_date?.split("T")[0],
          eta: orderedPart?.eta?.split("T")[0],
        }))}
      />
    </InfoBar>
  );
};

export default OrderedPartsInfoBar;
